// @ts-nocheck
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const fallbackImage = '/img/TH-placeholder.png';

const ImageSection = ({ images, hideInPdf = false }) => {
  if (!images || images.length < 1) return null;

  // Determine the CSS class based on the number of images
  const getImageGridClass = (count) => {
    switch (count) {
      case 1:
        return 'service-section__images--single';
      case 2:
        return 'service-section__images--double';
      case 3:
        return 'service-section__images--triple';
      case 4:
        return 'service-section__images--quad';
      case 5:
        return 'service-section__images--five';
      default:
        return 'service-section__images--multiple';
    }
  };

  const gridClass = getImageGridClass(images.length);

  return (
    <Box
      className={`service-section__images ${gridClass} ${hideInPdf ? 'noprint' : ''}`}
    >
      {images.map(
        (image, index) =>
          image && (
            <img
              src={image}
              alt={`Service image ${index + 1}`}
              style={{ display: 'block' }}
              key={image}
              onError={(evt) => {
                evt.target.src = fallbackImage;
              }}
            />
          )
      )}
    </Box>
  );
};

ImageSection.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  hideInPdf: PropTypes.bool
};
export default ImageSection;
